import { Glyph, GLYPH_LEGEND } from "../glyphs";

/**
 * The vocabulary, rendered once. Every screen that leans on the glyphs can show
 * this instead of repeating labels next to each mark.
 */
export default function GlyphLegend({ className }: { className?: string }) {
  return (
    <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-4 ${className ?? ""}`}>
      {GLYPH_LEGEND.map((group) => (
        <div key={group.heading}>
          <h3 className="text-xs uppercase tracking-wide opacity-50 mb-2">{group.heading}</h3>
          <ul className="space-y-1.5">
            {group.items.map(({ spec }) => (
              <li key={spec.label} className="flex items-center gap-2 text-sm">
                <Glyph shape={spec.shape} tone={spec.tone} size="sm" />
                <span>{spec.label}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
